module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page page-on-center",
    attrs: {
      "id": "direct-debit-sendbox",
      "data-page": "sendbox-page"
    },
    on: {
      "ptr:refresh": function($event) {
        return _vm.onRefresh(false)
      }
    }
  }, [_c('div', {
    staticClass: "showSmallScreenOnly",
    class: _vm.colorBottomButton
  }, [_c('f7-fab', {
    staticClass: "leftfav2 button-fab bottomButton floatingButtonToolbarBlank",
    on: {
      "click": _vm.openCreateRequest
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  })], 1), _vm._v(" "), _c('f7-fab', {
    staticClass: "leftfav button-fab bottomButton floatingButtonToolbarBlank",
    on: {
      "click": function($event) {
        return _vm.extractCSV(_vm.sendboxMessages)
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "document_text"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-content filterHeight heightifLargeScreen",
    staticStyle: {
      "z-index": "9"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row rowBackgroundImage showLargeScreenOnly"
  }, [_c('div', {
    staticClass: "row rowSearchBar",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "firstButtonMarginLeft showLargeScreenOnly"
  }, [_c('button', {
    staticClass: "new-button milkyBlock boxRequest",
    on: {
      "click": _vm.openCreateRequest
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "add"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Create new request")])], 1)]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "new-button milkyBlock pull-right",
    on: {
      "click": function($event) {
        return _vm.extractCSV(_vm.sendboxMessages)
      }
    }
  }, [_c('f7-icon', {
    attrs: {
      "f7": "document_text"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Extract CSV")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "searchFilter searchFilterWithoutTabs"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": _vm.serviceName,
      "popoverName": "",
      "subNavTitle": "Sent Modular Loan Requests",
      "menuAccess": true,
      "paymentsNumber": _vm.directDebitNumber
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " infinite-scroll pull-to-refresh-content ",
    staticStyle: {
      "z-index": "9"
    },
    on: {
      "infinite": _vm.onInfinite
    }
  }, [_c('transactions-list', {
    attrs: {
      "filterBy": _vm.filterBy,
      "outMessages": _vm.sendboxMessages
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toolbarPageBottomBlank"
  })], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-to-refresh-layer"
  }, [_c('div', {
    staticClass: "preloader"
  }), _vm._v(" "), _c('div', {
    staticClass: "pull-to-refresh-arrow"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9f1d3ab0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9f1d3ab0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/services/directDebit/SendboxPage.vue
// module id = 1704
// module chunks = 2